enum BoxPreviewStatus {
  SENT = 'SENT',
  NOTIFIED = 'NOTIFIED',
  EXPIRED = 'EXPIRED',
  SUBMITTED = 'SUBMITTED',
}

export interface BoxPreviewProjection {
  readonly id: string;
  readonly status: BoxPreviewStatus;
}

export {BoxPreviewStatus};
